var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvenience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 15458"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 65",
    cx: 11.1111,
    cy: 38.8885,
    r: 10.8333,
    stroke: "#FF2D20",
    strokeWidth: 0.555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 66",
    cx: 36.1111,
    cy: 11.1111,
    r: 10.8333,
    stroke: "#0000FF",
    strokeWidth: 0.555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 67",
    cx: 22.2223,
    cy: 25.0001,
    r: 19.4444,
    fill: "#FD5901"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 68",
    cx: 2.77778,
    cy: 5.55512,
    r: 2.77778,
    fill: "#FD5901",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 69",
    cx: 46.6667,
    cy: 38.8891,
    r: 2.77778,
    fill: "#FD5901",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.815 23.8707C21.715 23.8607 21.595 23.8607 21.485 23.8707C20.3372 23.8318 19.2496 23.3476 18.4526 22.5207C17.6556 21.6938 17.2117 20.5892 17.215 19.4407C17.215 16.9907 19.195 15.0007 21.655 15.0007C22.2374 14.9902 22.8162 15.0945 23.3583 15.3077C23.9004 15.5209 24.3952 15.8387 24.8144 16.2431C25.2337 16.6475 25.5692 17.1306 25.8018 17.6646C26.0344 18.1987 26.1595 18.7733 26.17 19.3557C26.1805 19.9381 26.0762 20.5169 25.863 21.059C25.6498 21.6011 25.332 22.0959 24.9276 22.5152C24.5232 22.9344 24.0402 23.2699 23.5061 23.5025C22.9721 23.7351 22.3974 23.8602 21.815 23.8707ZM16.815 27.5607C14.395 29.1807 14.395 31.8207 16.815 33.4307C19.565 35.2707 24.075 35.2707 26.825 33.4307C29.245 31.8107 29.245 29.1707 26.825 27.5607C24.085 25.7307 19.575 25.7307 16.815 27.5607Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvenience);
export default __webpack_public_path__ + "static/media/Convenience.6d5dc7d9c289db02f3631d68025669d8.svg";
export { ForwardRef as ReactComponent };